import { clsx } from 'clsx';

export interface StatusBadgeProps {
  status: 'critical' | 'warning' | 'info' | 'success' | 'neutral';
  label: string;
  size?: 'xs' | 'sm' | 'md';
  pulse?: boolean;
}

const STATUS_COLORS: Record<string, { dot: string; bg: string; text: string }> = {
  critical: { dot: 'bg-danger', bg: 'bg-danger-soft', text: 'text-danger' },
  warning: { dot: 'bg-warn', bg: 'bg-warn-soft', text: 'text-warn' },
  info: { dot: 'bg-primary', bg: 'bg-primary-soft', text: 'text-primary-bright' },
  success: { dot: 'bg-success', bg: 'bg-success-soft', text: 'text-success' },
  neutral: { dot: 'bg-ink-dim', bg: 'bg-surface-2', text: 'text-ink-dim' },
};

const SIZE_MAP = {
  xs: { wrapper: 'px-1.5 py-0.5 text-2xs', dot: 'h-1.5 w-1.5' },
  sm: { wrapper: 'px-2 py-0.5 text-2xs', dot: 'h-2 w-2' },
  md: { wrapper: 'px-2.5 py-1 text-2xs', dot: 'h-2 w-2' },
};

export function StatusBadge({ status, label, size = 'sm', pulse = false }: StatusBadgeProps) {
  const colors = (STATUS_COLORS[status] ?? STATUS_COLORS['neutral'])!;
  const s = SIZE_MAP[size];
  const shouldPulse = pulse || status === 'critical';
  return (
    <span className={clsx('inline-flex items-center gap-1 rounded-full font-medium', colors.bg, colors.text, s.wrapper, shouldPulse && 'animate-pulse-subtle')}>
      <span className={clsx('shrink-0 rounded-full', colors.dot, s.dot, shouldPulse && 'animate-pulse')} />
      <span className="capitalize">{label}</span>
    </span>
  );
}
